import { useEffect, useMemo, useRef } from 'react'
import useHover from 'hooks/useHover'
import { useSelector } from 'react-redux'
import { selectSideBarCloseBlocked } from '../../slice'

type UseItemHoverProps = {
  onHover?: (isOpen: boolean) => void
}
export const useItemHover = ({ onHover }: UseItemHoverProps) => {
  const prevIsHovered = useRef(false)
  const [ref, isHovered, setIsHoverOpen] = useHover<HTMLDivElement>({
    delay: 200,
    leaveDelay: 400,
  })
  const isCloseBlocked = useSelector(selectSideBarCloseBlocked)
  const isHoverOpen = useMemo(
    () => isHovered || (prevIsHovered.current && isCloseBlocked),
    [isHovered, isCloseBlocked],
  )

  useEffect(() => {
    onHover?.(isHoverOpen)
    prevIsHovered.current = isHovered
  }, [isHoverOpen])

  return {
    ref,
    setIsHoverOpen,
    isHoverOpen,
  }
}
